
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.4 0H2.6v24h18.8V4l-4-4z","fill":"#E8E8E8"}}),_c('path',{attrs:{"d":"M16.686 4.885h-9.49v9.49h9.49v-9.49z","fill":"#38A3FF"}}),_c('path',{attrs:{"d":"M14.628 9.711l-1.885 3.18-3.066-5.174-2.481 4.186v2.472h9.49v-1.191L14.628 9.71z","fill":"#007934"}}),_c('path',{attrs:{"d":"M18.02 2H2.6V0h14.8l.62 2z","fill":"#38A3FF"}}),_c('path',{attrs:{"d":"M7.466 22.872a2.51 2.51 0 01-.532-.055v-.797l.176.035c.063.013.13.02.203.02.17 0 .29-.052.364-.154.072-.102.109-.277.109-.525v-3.515h1.03v3.427c0 .514-.112.904-.337 1.168-.225.264-.563.396-1.013.396zm4.929-3.782c0 .424-.126.751-.376.983-.25.23-.606.346-1.066.346h-.289v1.26H9.638v-3.798h1.315c.48 0 .84.105 1.08.315.241.21.362.507.362.893zm-1.73.493h.186a.51.51 0 00.368-.13.471.471 0 00.136-.358c0-.257-.142-.385-.426-.385h-.265v.873zm3.86-.127h1.639v2.047a4.51 4.51 0 01-1.468.228c-.585 0-1.038-.17-1.357-.509-.32-.34-.48-.824-.48-1.452 0-.613.175-1.09.525-1.432.35-.34.84-.511 1.47-.511.24 0 .465.022.677.067.212.045.397.103.555.172l-.325.805a2.009 2.009 0 00-.901-.203c-.3 0-.531.098-.695.293-.164.194-.246.473-.246.835 0 .355.074.626.222.812.149.186.362.279.64.279.153 0 .293-.015.422-.044v-.595h-.678v-.793z","fill":"#A4A9AD"}}),_c('path',{attrs:{"d":"M17.4 4h4l-4-4v4z","fill":"#D1D3D3"}})])
          )
        }
      }
    